import { render, staticRenderFns } from "./servicio.vue?vue&type=template&id=c3731bf0&"
import script from "./servicio.vue?vue&type=script&lang=js&"
export * from "./servicio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports